import {Injectable} from '@angular/core';
import {NewUpload, Upload} from '../upload-repository';
import {UploadCollectionResponse} from '../upload-repository';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BaseTag} from '../../entities';
import {TagCollectionResponse} from '../upload-repository';
import {ApiService} from '../base';
import {ItemCreatedResponse} from '../../entities';

@Injectable({
  providedIn: 'root'
})
export class PatientUploadsRepositoryService {

  constructor(private api: ApiService) {
  }

  loadAll(id: number, tags: string[]): Observable<Upload[]> {
    const tagsParam = tags.length > 0 ? {tags: tags.join(',')} : null;
    return this.api.get<UploadCollectionResponse>('/uploads/patients/' + id, tagsParam)
      .pipe(map(response => response.items));
  }

  queryTags(query: string): Observable<BaseTag[]> {
    return this.api.get<TagCollectionResponse>('/uploads/tags/search/', {query: query})
      .pipe(map(response => response.items));
  }

  create(upload: NewUpload): Observable<number> {
    return this.api.post<ItemCreatedResponse>('/uploads/patients/' + upload.patientId, upload)
      .pipe(map(response => response.value));
  }
}
